import Vue from "vue"
import { scrollToFirstError, parseError } from "@/utils/error"

export default Vue.extend({
  props: {
    isLoading: { type: Boolean, default: false },
    parsedError: {
      type: Object as VuePropType<Record<string, any>>,
      default: () => ({
        message: "",
        context: {},
      }),
    },
  },

  data () {
    return {
      isLoadingModel: this.isLoading,
      parsedErrorModel: { ...this.parsedError },
    }
  },

  watch: {
    isLoading (isLoading) {
      this.isLoadingModel = isLoading
    },

    isLoadingModel (isLoadingModel) {
      this.$emit("update:isLoading", isLoadingModel)
    },
  },

  methods: {
    async handleError (error: any) {
      const parsedError = parseError(error)
      this.parsedErrorModel = parsedError

      this.$nuxt.$emit("reset-captcha")

      await this.$nextTick()
      this.scrollToFirstError()

      console.error(error.message)
    },

    scrollToFirstError () {
      scrollToFirstError()
    },
  },
})
